import { render, staticRenderFns } from "./ClientedForms.vue?vue&type=template&id=0d55f935"
import script from "./ClientedForms.vue?vue&type=script&lang=js"
export * from "./ClientedForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports